import { useState } from 'react'
import * as Yup from 'yup'

import type { IVideoSubmit } from './VideoForm'
import type { ReactElement } from 'react'
import type { IVideoResultItem, IVideoUpdate } from '~/types/video'

import VideoForm from './VideoForm'

import { useUpdateVideoMutation } from '../queries'

import Modal from '~/components/Modal'
import { ModalHeader } from '~/components/Modal/Layout'
import MwMLoader from '~/components/MwMLoader'
import { FORM_ERRORS } from '~/const'
import { displayToast } from '~/utils/toast'
import { YupOption } from '~/utils/yup'

import './styles.scss'

export const MODAL_ID = 'manage-video-modal'

interface ModalProps {
  isOpen: boolean
  onClose: VoidFunction
  onSubmit: VoidFunction
  video: IVideoResultItem
}

const validationSchema: Yup.ObjectSchema<Yup.AnyObject> = Yup.object({
  category: Yup.object({
    label: Yup.string(),
    value: Yup.string(),
  }),
  description: Yup.string(),
  tags: Yup.array().of(YupOption),
  title: Yup.string().required(FORM_ERRORS.REQUIRED),
})

const UpdateModal = ({ isOpen, onClose, onSubmit, video }: ModalProps): ReactElement => {
  const [lockModal, setLockModel] = useState(false)

  const { mutateAsync: updateVideoMutation } = useUpdateVideoMutation()

  const handleSubmit = async (data: IVideoSubmit) => {
    setLockModel(true)
    try {
      const { category, description, tags, title } = data.data as IVideoUpdate
      await updateVideoMutation({ category, description, id: video.id, tags, title })
      displayToast('Video successfully updated', 'success')
      onSubmit()
      onClose()
    } catch {
      displayToast('Video could not be updated', 'error')
    } finally {
      setLockModel(false)
    }
  }

  return (
    <Modal id={MODAL_ID} isOpen={isOpen} onCloseModal={onClose}>
      <ModalHeader>Update a video</ModalHeader>
      <VideoForm
        onCancel={onClose}
        onSubmit={handleSubmit}
        type="update"
        validationSchema={validationSchema}
        video={video}
      />
      {lockModal && <MwMLoader category="general" />}
    </Modal>
  )
}

export default UpdateModal
